import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Box } from "@mui/material";
import AccessorialsStepOne from "./AccessorialsStepOne/AccessorialsStepOne";
import AccessorialsStepTwo from "./AccessorialsStepTwo/AccessorialsStepTwo";
import { CarrierService } from "../../../../../services/CarrierService";
import { AlertContext } from "../../../../Dashboard/Dashboard";

export default function Accessorials({
  activeUser,
  activeLoad,
  handleClose
}) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [step, setStep] = useState(1);
  const [accessorialTypes, setAccessorialTypes] = useState([]);
  const [stagedAccessorialsArray, setStagedAccessorialsArray] = useState([]);
  const [allSubmitted, setAllSubmitted] = useState(false);
  const [accessorialToEdit, setAccessorialToEdit] = useState({});
  const [addNew, setAddNew] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleCancel = () => {
    handleClose();
  };

  const handleDeleteAccessorial = (accessorialToDelete) => {
    if (accessorialToDelete.accessorialId) {
      CarrierService.DeleteCarrierExtraPay(instance, accessorialToDelete).catch(error => {
        console.error(error);
        warning(error);
      });
    }

    const accessorials = [...stagedAccessorialsArray];
    setStagedAccessorialsArray(accessorials.filter(a => a.tempId !== accessorialToDelete.tempId));
    setDeleteModalOpen(false);
  };

  const handleUpdateAccessorial = (accessorial) => {
    const accessorials = [...stagedAccessorialsArray];
    const index = stagedAccessorialsArray.findIndex(a => a.tempId === accessorial.tempId);
    accessorials.splice(index, 1, accessorial);
    setStagedAccessorialsArray(accessorials);
  };

  useEffect(() => {
    const accessorials = JSON.parse(localStorage.getItem("accessorials"));

    if (activeLoad?.stops && accessorials) {
      accessorials.forEach(a => {
        const stop = activeLoad.stops.find(stop => stop.id === a.stop_id);
        a.accessorialId = a.id;
        a.tempId = a.id;
        a.stopSequence = stop?.orderSequence;
        a.amount = a.rate;
        a.totalAmount = a.amount_n;
      });
      setStagedAccessorialsArray(accessorials);
      setStep(2);
    }
  }, [activeLoad]);

  useEffect(() => {
    CarrierService.GetCarrierExtraPayTypes(instance).then(res => {
      setAccessorialTypes(res);
    }).catch(error => {
      console.error(error);
      warning(error);
    });
  }, []);

  return (
    <Box sx={{ height: "100%", overflow: "auto", paddingRight: "40px" }}>
      {step === 1 &&
        <AccessorialsStepOne
          activeUser={activeUser}
          activeLoad={activeLoad}
          accessorialTypes={accessorialTypes}
          stagedAccessorialsArray={stagedAccessorialsArray}
          setStagedAccessorialsArray={setStagedAccessorialsArray}
          accessorialToEdit={accessorialToEdit}
          setStep={setStep}
          addNew={addNew}
          handleCancel={handleCancel}
        />
      }
      {step === 2 &&
        <AccessorialsStepTwo
          stagedAccessorialsArray={stagedAccessorialsArray}
          setAccessorialToEdit={setAccessorialToEdit}
          setStep={setStep}
          handleDeleteAccessorial={handleDeleteAccessorial}
          handleUpdateAccessorial={handleUpdateAccessorial}
          handleClose={handleClose}
          allSubmitted={allSubmitted}
          setAllSubmitted={setAllSubmitted}
          setAddNew={setAddNew}
          deleteModalOpen={deleteModalOpen}
          setDeleteModalOpen={setDeleteModalOpen}
        />
      }
    </Box>
  );
}

Accessorials.propTypes = {
  activeUser: PropTypes.object,
  activeLoad: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired
};